import React from "react";
import { Grid, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import { useTranslation } from "react-i18next";

const ContactView = (props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color="textPrimary" variant="h5">
          {t("register.contact_title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("register.telephone_number")}
          name="telephone_number"
        />
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("register.cellular_number")}
          name="cellular_number"
        />
      </Grid>
      {props.installer ? (
        <Grid item xs={12}>
          <EditText
            {...props}
            label={t("register.vat_number")}
            name="vat_number"
          />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default ContactView;
